import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Section10B from "./Section10B";
import Section10C from "./Section10C";
import Section10D from "./Section10D";
import Section10E from "./Section10E";

const Section10A = ({data, index}) => {
  return (
    <>
      <Box
        sx={{ display: "flex", flexDirection: "row", justifyContent: "center" }}
      >
        <Stack
          sx={{
            backgroundColor: "white",
            // padding: "40px 20px",
            textAlign: "left",
            marginBottom: { xl: "32px" },
            // width: { xl: "72%", lg: "80%", md: "95%", sm: "94%", xs: "100%" },
            width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
            // border: "1px solid red",
            marginTop: "32px",
          }}
        >
        
          <Stack
            sx={{
              fontFamily: "'Roboto', sans-serif",
              fontSize: {
                xs: "20px",
                sm: "30px",
                md: "28px",
                lg: "40px",
                xl: "40 px",
              },
              lineHeight: {
                xs: "24px",
                sm: "36px",
                md: "32px",
                lg: "48px",
                xl: "48px",
              },
              fontWeight: 600,
              color: "rgb(5 78 146)",
              textAlign: "center",
              marginBottom: {
                xs: "20px",
                sm: "20px",
                md: "20px",
                lg: "20px",
                xl: "20px",
              },
              marginTop: {
                xs: "20px",
                sm: "20px",
                md: "40px",
                lg: "64px",
                xl: "64px",
              },
              // border: "1px solid red",
              display: "flex",
              flexDirection: "row",
            }}
          >          

            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "6px", lg: "6px", xs: "4px" },
                  // height: { xl: "100%", lg: "100%", xs: "100%" },
                  height: {
                    xs: "20px",
                    sm: "44px",
                    md: "28px",
                    lg: "40px",
                    xl: "40px",
                  },
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  border: "1px solid rgb(5 78 146)",
                  // backgroundColor: "rgb(5 78 146)",
                  backgroundColor: "rgb(5 78 146)",
                  marginRight: {
                    xs: "8px",
                    sm: "8px",
                    md: "12px",
                    lg: "12px",
                    xl: "12px",
                  },
                  borderTopRightRadius: "8px", // Adjust the value as needed
                  borderBottomRightRadius: "8px", // Adjust the value as needed
                }}
              >
                <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
              </Stack>
            </Stack>
            <span style={{ display: "inline-flex", alignItems: "center" }}>
             WhatsApp Real Estate Use Cases 
            </span>
          </Stack>

          <Stack
            sx={{
              width: { xs: "100%", sm: "50%" },
              fontFamily: "'Roboto', sans-serif",
              fontSize: {
                xs: "16px",
                sm: "16px",
                md: "16px",
                lg: "24px",
                xl: "24px",
              },
              lineHeight: {
                xs: "24px",
                sm: "28px",
                md: "32px",
                lg: "32px",
                xl: "32px",
              },
              fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
              color: "#333",
              border: "1px solid #f1f8ff",
              textAlign: "left",
              // border: "1px solid rgb(218 233 248)",
              padding: 1,
              borderRadius: "8px",
              backgroundColor: "#f1f8ff",
              marginBottom: {
                xs: "20px",
                sm: "20px",
                md: "20px",
                lg: "64px",
                xl: "64px",
              },
            }}
          >
            Key Features of WhatsApp Business API for Real Estate
          </Stack>
        </Stack>
      </Box>
      <Section10B data={data} index={index}/>
      <Section10C data={data} index={index}/>
      <Section10D data={data} index={index}/>
      <Section10E data={data} index={index}/>
    </>
  );
};

export default Section10A;
